<template>
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-full"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-full"
  >
    <div
      v-if="isVisible"
      class="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div class="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div class="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div class="min-w-0 flex-1 space-y-1">
            <h2
              id="cookie-consent-title"
              class="text-sm font-semibold text-gray-900 dark:text-white"
            >
              {{ $t('cookieConsent.title') }}
            </h2>
            <p
              id="cookie-consent-desc"
              class="text-sm text-gray-700 dark:text-gray-300"
            >
              {{ $t('cookieConsent.message') }}
              <router-link
                to="/privacy-policy"
                class="font-medium text-primary underline hover:text-primary-accent"
              >
                {{ $t('cookieConsent.privacyPolicy') }}
              </router-link>
            </p>
          </div>

          <div class="flex flex-shrink-0 items-center gap-3">
            <UIButton
              variant="outline"
              size="sm"
              @click="handleReject"
            >
              {{ $t('cookieConsent.reject') }}
            </UIButton>
            <UIButton
              variant="primary"
              size="sm"
              @click="handleAccept"
            >
              {{ $t('cookieConsent.accept') }}
            </UIButton>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useCookieConsent } from '@/composables/useCookieConsent'
import UIButton from './UIButton.vue'
import { createLogger } from '@/utils/logger'

const fileLogger = createLogger('UICookieConsent')

const { hasConsented, acceptCookies, rejectCookies } = useCookieConsent()

const isVisible = computed(() => !hasConsented.value)

const handleAccept = () => {
  fileLogger.log('User accepted cookies')
  acceptCookies()
}

const handleReject = () => {
  fileLogger.log('User rejected cookies')
  rejectCookies()
}
</script>
